import * as React from 'react';
import { useContext, useEffect, useRef, useState } from 'react';
import { Accordion, AccordionContext, Button, Card, useAccordionToggle } from 'react-bootstrap';

function FilterLink({ children, eventKey, callback }) {
    const currentEventKey = useContext(AccordionContext);

    const decoratedOnClick = useAccordionToggle(
        eventKey,
        () => callback && callback(eventKey),
    );
    const active = currentEventKey === eventKey;

    return <div className="headerBlock" onClick={decoratedOnClick}>
        <h4 className="body_title mb-0" > {children} </h4>
        <i className={`fa fa-${active ? 'minus' : 'plus'}`}></i>
    </div>

}

function SchoolSearchHelp({ close, tourOpen, helpContent }) {
    return <div className="help_window_container bs-shim" >
        <div className="page-close-bar help">
            <div className="shortName">Help</div>
            <button className="btn close-btn" onClick={() => close(true)}></button>
        </div>

        <div className="help_container" >
            <div dangerouslySetInnerHTML={{ __html: helpContent }} />
            <div className="text-block" id="help_tour_section">
                <h4 className="body_title" >Take the Tour</h4>
                <button className="btn" onClick={() => tourOpen(true)}>Tour</button>
            </div>
        </div>
    </div>;
}

export default SchoolSearchHelp;
